// LIST
export const FETCH_FEEDS = "app/FEED/FETCH_FEEDS";
export const FETCH_FEEDS_SUCCESS = "app/FEED/FETCH_FEEDS_SUCCESS";
export const FETCH_FEEDS_FAILURE = "app/FEED/FETCH_FEEDS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/FEED/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/FEED/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/FEED/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_FEED = "app/FEED/ADD_FEED";
export const ADD_FEED_SUCCESS = "app/FEED/ADD_FEED_SUCCESS";
export const ADD_FEED_FAILURE = "app/FEED/ADD_FEED_FAILURE";

// EDIT
export const EDIT_FEED = "app/FEED/EDIT_FEED";
export const EDIT_FEED_SUCCESS = "app/FEED/EDIT_FEED_SUCCESS";
export const EDIT_FEED_FAILURE = "app/FEED/EDIT_FEED_FAILURE";

// DELETE
export const DELETE_FEED = "app/FEED/DELETE_FEED";
export const DELETE_FEED_SUCCESS = "app/FEED/DELETE_FEED_SUCCESS";
export const DELETE_FEED_FAILURE = "app/FEED/DELETE_FEED_FAILURE";

export const TOGGLE_FEED_ADD_MODAL = "app/FEED/TOGGLE_FEED_ADD_MODAL";

// SET FEED FILTER
export const SET_FEED_FILTER = "app/FEED/SET_FEED_FILTER";

export const UPDATE_FORM_VALUES = "app/FEED/UPDATE_FORM_VALUES";
export const RESET_FORM_VALUES = "app/FEED/RESET_FORM_VALUES";
export const UPDATE_MEDIA_FILES = "app/FEED/UPDATE_MEDIA_FILES";

export const TOGGLE_DELETE = "app/FEED/TOGGLE_DELETE";

export const ADD_VOTE = "app/FEED/ADD_VOTE";
export const ADD_VOTE_SUCCESS = "app/FEED/ADD_VOTE_SUCCESS";
export const ADD_VOTE_FAILURE = "app/FEED/ADD_VOTE_FAILURE";
